// Owner: shell-nav (wave 2). Authenticated full-screen layout without a rail (builders, wizards): recent
// items are remembered, an unreachable API shows the same banner (floating), errors get a designed state.
import { Outlet, createFileRoute } from '@tanstack/react-router';
import { useAppBrand } from '../features/branding/app-brand';
import { requireSession } from '../lib/auth';
import { useRealtimeChannel } from '../lib/realtime-channel';
import { ConnectivityBanner } from '../shell/connectivity';
import { PathnameProvider } from '../shell/pathname';
import { useTrackRecent } from '../shell/recent';
import { PageError, PagePending, RootNotFound } from '../shell/states';

export const Route = createFileRoute('/_focus')({
  beforeLoad: ({ location }) => requireSession(location),
  component: FocusLayout,
  pendingComponent: PagePending,
  notFoundComponent: RootNotFound,
  errorComponent: PageError,
});

function FocusLayout() {
  useRealtimeChannel();
  useTrackRecent();
  // Builders show the workspace brand's accent and tab icon like the app (F3).
  useAppBrand();
  return (
    <PathnameProvider>
      <div className="shell-banner-floating">
        <ConnectivityBanner />
      </div>
      <Outlet />
    </PathnameProvider>
  );
}
